import React from "react";
import LogoImage from "../../assets/logo.png";

const Logo = () => {
	return (
		<>
			<img src={LogoImage} alt="Logo" width={67} height={34} />
		</>
	);
};

export default Logo;
